import { useState, type FormEvent } from 'react';
import { ApiError, Button, ErrorNote, Field, Input, useAuth } from '@mobi/web';

/**
 * Só login. Conta de admin não se cria pelo app — nasce pelo script
 * `scripts/create-admin` — e por isso não há aba de cadastro aqui.
 */
export function Auth() {
  const { login } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login({ email, password, totp: totp || undefined });
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : err instanceof Error
            ? err.message
            : 'não foi possível entrar',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="h-app overflow-y-auto bg-surface">
      <div className="mx-auto flex min-h-full w-full max-w-sm flex-col items-center justify-center px-6 py-12">
        <div className="mb-10 flex flex-col items-center text-center">
          <img src="/brand-wordmark.png?v=1" alt="WiGo" className="mb-6 h-[3.75rem] w-auto" />
          <h1 className="text-2xl font-bold tracking-tight">Administração</h1>
          <p className="mt-2 text-muted">Acesso restrito, com verificação em duas etapas.</p>
        </div>

        <form onSubmit={submit} className="w-full space-y-4">
          <Field label="E-mail">
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              placeholder="voce@email.com"
            />
          </Field>

          <Field label="Senha">
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </Field>

          <Field label="Código do autenticador" hint="6 dígitos, do app TOTP">
            <Input
              value={totp}
              onChange={(e) => setTotp(e.target.value)}
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={6}
              required
              placeholder="000000"
            />
          </Field>

          {error && <ErrorNote>{error}</ErrorNote>}

          <Button type="submit" size="lg" full loading={busy}>
            Entrar
          </Button>
        </form>
      </div>
    </div>
  );
}
